<div class="select-classroom-dialog" [class.dialog-expanded]="autoClassroom.isOpen">
  <span class="select-classroom-dialog-title">Vincular turmas</span>

  <div class="select-classroom-dialog-options">
    <app-school-year-combo
      [txtYear]="startTxtYear"
      (yearSelected)="getYearSelected($event)"
    >
    </app-school-year-combo>
  </div>

  <div class="select-fields">
    <mat-form-field
      appearance="outline"
      class="pointer-cursor"
      (click)="openList($event, triggerClassroom)"
    >
      <mat-label>Turmas</mat-label>
      <input
        #triggerClassroom="matAutocompleteTrigger"
        type="text"
        matInput
        [matAutocomplete]="autoClassroom"
        value="{{ txtClassrooms }}"
        class="pointer-cursor"
        readonly
      />
      <mat-autocomplete #autoClassroom="matAutocomplete">
        <mat-option [style.display]="'none'"></mat-option>
        <app-select-hierarquical-list
          *ngIf="segmentTreeData.length > 0"
          [treeData]="segmentTreeData"
          [initialSelection]="selectedIdsClassrooms"
          (selectEvent)="handleSelect($event)"
          [hideButtons]="true"
        >
        </app-select-hierarquical-list>
      </mat-autocomplete>

      <span matSuffix class="material-icons" *ngIf="!autoClassroom.isOpen">
        expand_more
      </span>

      <span matSuffix class="material-icons" *ngIf="autoClassroom.isOpen">
        expand_less
      </span>
    </mat-form-field>
  </div>

  <div class="flex-btn" [class.footer]="autoClassroom.isOpen">
    <button mat-raised-button class="btn-clear" (click)="closeComponent()">
      Cancelar
    </button>
    <button
      mat-raised-button
      [ngClass]="showClassroomsCombo ? '' : 'btn-save-enabled'"
      class="btn-save"
      (click)="saveComponent()"
    >
      Salvar
    </button>
  </div>
</div>
